import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./notifications";

Vue.config.productionTip = false;

init();

async function init() {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
  }).$mount("#app");
}
